var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 803,
    viewBox: "0 0 1440 803",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-87.8827 255.127C53.9025 219.727 272.478 211.425 484.005 228.133C695.546 244.843 899.922 286.558 1013.35 351.124L1013.83 350.283C900.204 285.604 695.644 243.879 484.082 227.168C272.506 210.455 53.8124 218.752 -88.1174 254.187L-87.8827 255.127ZM1013.35 351.124C1126.84 415.728 1198.17 471.933 1259.1 535.922C1320.03 599.925 1370.56 671.716 1442.47 767.541L1443.24 766.96C1371.37 671.17 1320.79 599.31 1259.8 535.254C1198.8 471.185 1127.38 414.924 1013.83 350.283L1013.35 351.124Z",
    fill: "#3971E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.9832 305.359C88.2701 268.778 300.982 258.513 506.61 273.246C712.252 287.981 910.692 327.71 1020.44 391.045L1020.93 390.206C910.973 326.755 712.344 287.017 506.679 272.28C301.001 257.543 88.1688 267.803 -50.231 304.422L-49.9832 305.359ZM1020.44 391.045C1130.26 454.419 1199.14 509.803 1257.83 573.041C1316.53 636.293 1365.04 707.405 1434.11 802.285L1434.89 801.715C1365.84 706.871 1317.29 635.689 1258.54 572.382C1199.78 509.06 1130.81 453.619 1020.93 390.206L1020.44 391.045Z",
    fill: "#3971E7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLine);
export default __webpack_public_path__ + "static/media/doubleLine.e01a989d9f40ff3e9ec34f042d7a2648.svg";
export { ForwardRef as ReactComponent };